import { Flex } from 'antd';
import React, { ReactNode } from 'react';
import { GraphQLTaggedNode, useRelayEnvironment } from 'react-relay';

import { getObjectFromRelayStoreById } from '../functions';
import { ActionsType, CustomTableActionType, ItemTaskType, ItemType, TableColumnSmxType } from '../types';
import ActionButtonCustom from './ActionButtonCustom';
import ActionButtonDelete from './ActionButtonDelete';
import ActionButtonEdit from './ActionButtonEdit';

interface IActionBox {
    actions: ActionsType[];
    data?: any;
    editableColumns: TableColumnSmxType[];
    connectionId: string;
    mutationUpdate?: GraphQLTaggedNode;
    mutationDelete?: GraphQLTaggedNode;
    customActions?: CustomTableActionType[];
    customActionComponents?: ((item: ItemType | ItemTaskType, data: any) => ReactNode)[];
}

const ActionBox: React.FC<IActionBox> = ({
    actions,
    data,
    editableColumns,
    connectionId,
    mutationUpdate,
    mutationDelete,
    customActions,
    customActionComponents,
}) => {
    const environment = useRelayEnvironment();

    return (
        <Flex justify={'center'} gap={10}>
            {actions.includes('edit') && editableColumns.length && mutationUpdate && (
                <ActionButtonEdit
                    data={data}
                    connectionId={connectionId}
                    mutationUpdate={mutationUpdate}
                    editableColumns={editableColumns}
                />
            )}
            {actions.includes('delete') && mutationDelete && (
                <ActionButtonDelete connectionId={connectionId} id={data.key} mutationDelete={mutationDelete} />
            )}
            {customActions?.map((action, index) => {
                const dataRaw = getObjectFromRelayStoreById(environment, data.keyRaw);
                return <ActionButtonCustom key={index} action={action} data={data} dataRaw={dataRaw} />;
            })}
            {customActionComponents?.map((action, index) => {
                const dataRaw = getObjectFromRelayStoreById(environment, data.keyRaw);
                return <span key={index}>{action(dataRaw as any, data)}</span>;
            })}
        </Flex>
    );
};

export default ActionBox;
